module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "table-title mb-0"
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("\n        Detailed Billing Summary\n        "), _c('span', {
    staticClass: "badge badge-primary ml-2"
  }, [_vm._v(_vm._s(_vm.filteredBillingSummaryData.length) + " Clients")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-filters mb-3"
  }, [_c('b-row', {
    staticClass: "align-items-center"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingSearchQuery),
      expression: "billingSearchQuery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "type": "text",
      "placeholder": "SEARCH BY CLIENT NAME..."
    },
    domProps: {
      "value": (_vm.billingSearchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billingSearchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "color-legend"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('strong', [_vm._v("Color Legend:")]), _vm._v(" "), _c('span', {
    staticClass: "text-success font-weight-bold ml-2"
  }, [_vm._v("🟢 High (>₹5L)")]), _vm._v(" "), _c('span', {
    staticClass: "text-info ml-2"
  }, [_vm._v("🔵 Good (₹2L-5L)")]), _vm._v(" "), _c('span', {
    staticClass: "text-warning ml-2"
  }, [_vm._v("🟡 Medium (₹50K-2L)")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("⚪ Low (<₹50K)")])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive billing-summary-table"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "fixed-header",
    staticStyle: {
      "min-width": "60px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("S.No")]), _vm._v(" "), _c('th', {
    staticClass: "fixed-header sortable-header",
    staticStyle: {
      "min-width": "200px"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBillingBy('clientName')
      }
    }
  }, [_vm._v("\n                Client Name\n                "), _c('i', {
    staticClass: "fa",
    class: _vm.billingSortColumn === 'clientName' ? (_vm.billingSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'
  })]), _vm._v(" "), _vm._l((_vm.billingUniqueMonths), function(month) {
    return [_c('th', {
      staticClass: "month-header",
      attrs: {
        "colspan": 3
      }
    }, [_vm._v(_vm._s(month))])]
  }), _vm._v(" "), _c('th', {
    staticClass: "summary-header sortable-header",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBillingBy('totalExport')
      }
    }
  }, [_vm._v("\n                Export Total\n                "), _c('i', {
    staticClass: "fa",
    class: _vm.billingSortColumn === 'totalExport' ? (_vm.billingSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'
  })]), _vm._v(" "), _c('th', {
    staticClass: "summary-header sortable-header",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBillingBy('totalImport')
      }
    }
  }, [_vm._v("\n                Import Total\n                "), _c('i', {
    staticClass: "fa",
    class: _vm.billingSortColumn === 'totalImport' ? (_vm.billingSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'
  })]), _vm._v(" "), _c('th', {
    staticClass: "summary-header sortable-header",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.sortBillingBy('total')
      }
    }
  }, [_vm._v("\n                Total\n                "), _c('i', {
    staticClass: "fa",
    class: _vm.billingSortColumn === 'total' ? (_vm.billingSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'
  })])], 2), _vm._v(" "), _c('tr', [_vm._l((_vm.billingUniqueMonths), function(month) {
    return [_c('th', {
      staticClass: "sub-header"
    }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
      staticClass: "sub-header"
    }, [_vm._v("Export")]), _vm._v(" "), _c('th', {
      staticClass: "sub-header"
    }, [_vm._v("Import")])]
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredBillingSummaryData), function(client, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "fixed-cell"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "fixed-cell"
    }, [_c('strong', [_vm._v(_vm._s(client.clientName))])]), _vm._v(" "), _vm._l((_vm.billingUniqueMonths), function(month) {
      return [_c('td', {
        staticClass: "billing-cell billing-total-cell",
        class: _vm.getBillingAmountClass(client.monthsMap[month]),
        attrs: {
          "title": _vm.getBillingTooltip(client.monthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.monthsMap[month] ? _vm.formatCurrency(client.monthsMap[month]) : '-') + "\n                ")]), _vm._v(" "), _c('td', {
        staticClass: "billing-cell billing-export-cell",
        class: _vm.getBillingAmountClass(client.exportMonthsMap[month]),
        attrs: {
          "title": _vm.getBillingTooltip(client.exportMonthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.exportMonthsMap[month] ? _vm.formatCurrency(client.exportMonthsMap[month]) : '-') + "\n                ")]), _vm._v(" "), _c('td', {
        staticClass: "billing-cell billing-import-cell",
        class: _vm.getBillingAmountClass(client.importMonthsMap[month]),
        attrs: {
          "title": _vm.getBillingTooltip(client.importMonthsMap[month])
        }
      }, [_vm._v("\n                  " + _vm._s(client.importMonthsMap[month] ? _vm.formatCurrency(client.importMonthsMap[month]) : '-') + "\n                ")])]
    }), _vm._v(" "), _c('td', {
      staticClass: "billing-cell summary-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(client.totalExport)))])]), _vm._v(" "), _c('td', {
      staticClass: "billing-cell summary-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(client.totalImport)))])]), _vm._v(" "), _c('td', {
      staticClass: "billing-cell summary-cell"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(client.total)))])])], 2)
  }), _vm._v(" "), (_vm.filteredBillingSummaryData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": 2 + (_vm.billingUniqueMonths.length * 3) + 3
    }
  }, [_vm._v("\n                No data available\n              ")])]) : _vm._e()], 2)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32cf6f93","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/BillingSummarySection.vue
// module id = 2505
// module chunks = 0